import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

// Get the saved locale from localStorage, or default to "ar"
const savedLocale = localStorage.getItem("locale") || "ar";

const messages = {
  en,
  ar,
};

const i18n = createI18n({
  legacy: false, // Use Composition API if using Vue 3
  locale: savedLocale, // Use saved locale if available
  fallbackLocale: "ar", // Fallback if translation is missing
  messages,
  globalInjection: true, // Allows using `$t` globally
});

document.body.setAttribute("dir", savedLocale === "ar" ? "rtl" : "ltr");

export default i18n;
